/**
 * Returns a list of unique values
 * 
 * @param {object[]} list an array of objects that all duplicates need to be removed.
 * @param {string} field the field that needs to be unique
 * 
 * @returns array
 */
export const getUniqueValues = (list: object[], field: string) => {
  return [... new Map(list.map((item: any) => [item[field], item])).values()]
}